/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
var tipologia_cerco = "185", tipologia_offro = "184", tipologia_prestito = "209";
jQuery("input[name='inserimento-annuncio-tipologia']").click(function () {
    if (this.value == tipologia_offro || this.value == tipologia_prestito)//offro o prestito
    {
        jQuery("#inserimento-oggetto-tipologia-div").fadeIn("slow");
        jQuery("#inserimento-annuncio-altri-campi-div").fadeOut("slow");
        jQuery("#titolo_sez_foto").html("Inserisci una o più foto aggiornate dell\'oggetto che vuoi proporre");
    }
    else// cerco
    {
        jQuery("#inserimento-oggetto-tipologia-div").fadeOut("slow");
        jQuery("#inserimento-annuncio-altri-campi-div").fadeIn("slow");
        jQuery("#inserimento-crea-oggetto-div").fadeOut("slow");
        jQuery("#inserimento-annuncio-oggetti-presenti-div").fadeOut("slow");
        jQuery("#titolo_sez_foto").html("Inserisci una o più esemplificative dell\'oggetto che stai cercando");
    }
});
//jQuery("input[name='inserimento-annuncio-tipologia-ritiro']").click(function () {
//   if (this.value == 'good-croosing-point')//offro
//   {
//       jQuery('#inserimento-annuncio-altri-campi-good-crossing-point-div').show();
//       jQuery('#inserimento-annuncio-altri-campi-localizzazione-div').hide();
//       jQuery('#inserimento-annuncio-altri-campi-indirizzi-personali-div').hide();
//   }
//   else if(this.value == 'localizzazione')
//   {
//       jQuery('#inserimento-annuncio-altri-campi-localizzazione-div').show();
//       jQuery('#inserimento-annuncio-altri-campi-good-crossing-point-div').hide();
//       jQuery('#inserimento-annuncio-altri-campi-indirizzi-personali-div').hide();
//   }
//   else if(this.value == 'indirizzi-personali')
//   {
//       jQuery('#inserimento-annuncio-altri-campi-indirizzi-personali-div').show();
//       jQuery('#inserimento-annuncio-altri-campi-good-crossing-point-div').hide();
//       jQuery('#inserimento-annuncio-altri-campi-localizzazione-div').hide();
//   }
//});
jQuery(document).ready(function ($) {
    /**
     * 
     * PAGINA INSERIMENTO ANNUNCI
     * 
     * 
     * 
     */



    /*
     *  recupero oggetto disponibili via ajax
     */
    $("#button-inserimento-oggetto-presente").click(function () {
        themeSpinner('show');
        $.ajax({//create an ajax request to load_page.php
            type: "POST",
            cache: false,
            url: ajax_url,
            data:
                    {
                        action: 'recupera_oggetti_disponibili_action'
                    },
            dataType: "html", //expect html to be returned                
            success: function (response) {
                themeSpinner('hide');
                $("#inserimento-annuncio-oggetti-presenti").html(response);
                $("#inserimento-annuncio-oggetti-presenti-div").fadeIn("slow");
                $("#inserimento-crea-oggetto-div").fadeOut("slow");
            },
            error: function () {
                themeSpinner('hide');
                $("#messageSelectObject").html('Problemi nel recuperare gli oggetti');
                $("#messageSelectObject").addClass('alert-danger');
                $("#messageSelectObject").show();
            }

        });
    });
    $('#inserimento-crea-oggetto-nome').change(function () {
        rimuovi_stato('#inserimento-crea-oggetto-nome');
        $('#messageNewObject').html(''); // Add success message to results div
        $('#messageNewObject').removeClass('alert-danger');
        $('#messageNewObject').removeClass('alert-success'); // Add class success to results div
        $('#messageNewObject').hide();
    });
    $('#inserimento-crea-oggetto-descrizione').change(function () {

        rimuovi_stato('#inserimento-crea-oggetto-descrizione');
        $('#messageNewObject').html(''); // Add success message to results div
        $('#messageNewObject').removeClass('alert-danger');
        $('#messageNewObject').removeClass('alert-success'); // Add class success to results div
        $('#messageNewObject').hide();
    });
    $('#inserimento-crea-oggetto-categoria').change(function () {

        rimuovi_stato('#inserimento-crea-oggetto-categoria');
        $('#messageNewObject').html(''); // Add success message to results div
        $('#messageNewObject').removeClass('alert-danger');
        $('#messageNewObject').removeClass('alert-success'); // Add class success to results div
        $('#messageNewObject').hide();
    });
    if ($('#inserimento-annuncio-oggetti-presenti').val() !== null && $('#inserimento-annuncio-oggetti-presenti').val() !== '')
    {
        $("#inserimento-annuncio-altri-campi-div").fadeIn("slow");
    }
    $('#inserimento-annuncio-oggetti-presenti').change(function () {

        if (this.value === '' || this.value == '')
            $("#inserimento-annuncio-altri-campi-div").fadeOut("slow");
        else
        {
            $("#inserimento-annuncio-altri-campi-div").fadeIn("slow");
            $("#inserimento-annuncio-altri-campi-titolo").val($('#inserimento-annuncio-oggetti-presenti option:selected').text());
        }
    });
    function base64ToFile(base64Data, tempfilename, contentType) {
    contentType = contentType || '';
    var sliceSize = 1024;
    var byteCharacters = atob(base64Data);
    var bytesLength = byteCharacters.length;
    var slicesCount = Math.ceil(bytesLength / sliceSize);
    var byteArrays = new Array(slicesCount);

    for (var sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
        var begin = sliceIndex * sliceSize;
        var end = Math.min(begin + sliceSize, bytesLength);

        var bytes = new Array(end - begin);
        for (var offset = begin, i = 0 ; offset < end; ++i, ++offset) {
            bytes[i] = byteCharacters[offset].charCodeAt(0);
        }
        byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    var file = new File(byteArrays, tempfilename, { type: contentType });
    return file;
}
    $("#button-inserimento-crea-oggetto").click(function () {
        var reg_nome = $('#inserimento-crea-oggetto-nome').val();
        var reg_descrizione = $('#inserimento-crea-oggetto-descrizione').val();
        var reg_categoria = $('#inserimento-crea-oggetto-categoria').val();
        var reg_tagliaoggetto = $('#inserimento-crea-oggetto-taglia-oggetto').val();
        var reg_titolo = $('#inserimento-annuncio-altri-campi-titolo').val();
        //var reg_foto_1 = $('#inserimento-annuncio-altri-campi-foto-1').val();
        var reg_foto_1 = $('#inserimento-crea-oggetto-foto-1')[0].files[0];
        //var reg_foto_2 = $('#inserimento-annuncio-altri-campi-foto-2').val();
        var reg_foto_2 = $('#inserimento-crea-oggetto-foto-2')[0].files[0];
        //var reg_foto_3 = $('#inserimento-annuncio-altri-campi-foto-3').val();
        var reg_foto_3 = $('#inserimento-crea-oggetto-foto-3')[0].files[0];
        var faiAjax = true;
        if (reg_nome == '')
        {
            rimuovi_stato('#inserimento-crea-oggetto-nome');
            stato_errore('#inserimento-crea-oggetto-nome', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#inserimento-crea-oggetto-nome');
            stato_success('#inserimento-crea-oggetto-nome');
        }
        if (reg_categoria == null || reg_categoria == '')
        {
            rimuovi_stato('#inserimento-crea-oggetto-categoria');
            stato_errore('#inserimento-crea-oggetto-categoria', 'Campo richiesto');
            faiAjax = false;
        } else
        {
            rimuovi_stato('#inserimento-crea-oggetto-categoria');
            stato_success('#inserimento-crea-oggetto-categoria');
        }
        if (typeof(reg_foto_1) !== 'undefined' && reg_foto_1 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_1);
            if (tmp)
            {
                rimuovi_stato('#inserimento-crea-oggetto-foto');
                stato_success('#inserimento-crea-oggetto-foto');
            }
            else
            {
                faiAjax = false;
                rimuovi_stato('#inserimento-crea-oggetto-foto');
                msgtmp = 'Attenzione il file 1 deve essere in formato jpeg o png  e non superiore a 8MB';
                stato_errore('#inserimento-crea-oggetto-foto', msgtmp);
            }
        }
        else
        {
            if ($('input[name=inserimento-annuncio-tipologia]:checked').val() !== tipologia_cerco)// se non è un cerco  è obbligatoria la foto
            {
                faiAjax = false;
                rimuovi_stato('#inserimento-crea-oggetto-foto');
                msgtmp = 'Attenzione la foto 1 è obbligatoria';
                stato_errore('#inserimento-crea-oggetto-foto', msgtmp);
            }
        }
         if (typeof(reg_foto_2) !== 'undefined' && reg_foto_2 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_2);
            if (tmp)
            {
                rimuovi_stato('#inserimento-crea-oggetto-foto');
                stato_success('#inserimento-crea-oggetto-foto');
            }
            else
            {
                faiAjax = false;
                msgtmp += '<br>Attenzione il file 2 deve essere in formato jpeg o png  e non superiore a 8MB';
                rimuovi_stato('#inserimento-crea-oggetto-foto');
                stato_errore('#inserimento-crea-oggetto-foto', msgtmp);
            }
        }
         if (typeof(reg_foto_3) !== 'undefined' && reg_foto_3 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_3);
            if (tmp)
            {
                rimuovi_stato('#inserimento-crea-oggetto-foto');
                stato_success('#inserimento-crea-oggetto-foto');
            }
            else
            {
                faiAjax = false;
                msgtmp += '<br>Attenzione il file 3 deve essere in formato jpeg o png  e non superiore a 8MB';
                rimuovi_stato('#inserimento-crea-oggetto-foto');
                stato_errore('#inserimento-crea-oggetto-foto', msgtmp);
            }
        }
        if (faiAjax)
        {
            themeSpinner('show');
            form = new FormData();
            form.append('descrizione', $("#inserimento-crea-oggetto-descrizione").val());
            form.append('categoria', $("#inserimento-crea-oggetto-categoria").val());
            form.append('tagliaoggetto', $('#inserimento-crea-oggetto-taglia-oggetto').val());
            form.append('titolo', $("#inserimento-crea-oggetto-nome").val());
            
            var file1=null;
            var file2=null;
            var file3 =null;
            if (typeof(reg_foto_1) !== 'undefined' && reg_foto_1 != null)
            {
                dataURL1=$('#inserimento-crea-oggetto-immaginecompressa-1').attr('src');
                base64ToFile(dataURL1.split(',')[1], reg_foto_1.name, 'image/jpeg');
            }
            if (typeof(reg_foto_2) !== 'undefined' && reg_foto_2 != null)
            {
                dataURL2=$('#inserimento-crea-oggetto-immaginecompressa-2').attr('src');
                file2=base64ToFile(dataURL2.split(',')[1], reg_foto_2.name, 'image/jpeg');
            }
            if (typeof(reg_foto_3) !== 'undefined' && reg_foto_3 != null)
            {
                dataURL3=$('#inserimento-crea-oggetto-immaginecompressa-3').attr('src');
                file3=base64ToFile(dataURL3.split(',')[1], reg_foto_3.name, 'image/jpeg');
            }
            form.append('foto_1', file1);
            form.append('foto_2', file2);
            form.append('foto_3', file3);
            form.append('action', 'inserimento_oggetto_utente_action');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                data: form,
                mimeType: 'multipart/form-data',
                contentType: false,
                cache: false,
                processData: false,
                url: ajax_url,
                dataType: "html", //expect html to be returned                
                success: function (resp) {
                    themeSpinner('hide');
                    $("#messageNewObject").html('Oggetto inserito con successo, adesso pubblica il tuo annuncio');
                    $("#messageNewObject").addClass('alert-success');
                    $("#messageNewObject").show();
                    var file_1 = document.querySelector('#inserimento-crea-oggetto-foto-1');
                    var file_1c = document.querySelector('#inserimento-annuncio-altri-campi-foto-1');
                    $('#inserimento-annuncio-altri-campi-immaginecompressa-1').attr('src',$('#inserimento-crea-oggetto-immaginecompressa-1').attr('src'));
                    file_1c.files = file_1.files;
                    var file_2 = document.querySelector('#inserimento-crea-oggetto-foto-2');
                    var file_2c = document.querySelector('#inserimento-annuncio-altri-campi-foto-2');
                    $('#inserimento-annuncio-altri-campi-immaginecompressa-2').attr('src',$('#inserimento-crea-oggetto-immaginecompressa-2').attr('src'));
                    file_2c.files = file_2.files;
                    var file_3 = document.querySelector('#inserimento-crea-oggetto-foto-3');
                    var file_3c = document.querySelector('#inserimento-annuncio-altri-campi-foto-3');
                    $('#inserimento-annuncio-altri-campi-immaginecompressa-3').attr('src',$('#inserimento-crea-oggetto-immaginecompressa-3').attr('src'));
                    file_3c.files = file_3.files;
                    $('#inserimento-annuncio-altri-campi-foto-div').hide();
                    /*
                     *  recupero oggetto disponibili via ajax
                     */
                    $.ajax({//create an ajax request to load_page.php
                        type: "POST",
                        cache: false,
                        url: ajax_url,
                        data:
                                {
                                    action: 'recupera_oggetti_disponibili_action'
                                },
                        dataType: "html", //expect html to be returned                
                        success: function (response) {

                            themeSpinner('hide');
                            $("#inserimento-annuncio-oggetti-presenti").html(response);
                            $("#inserimento-annuncio-oggetti-presenti-div").hide();
                            $("#inserimento-annuncio-altri-campi-div").fadeIn("slow");
                            $("#inserimento-crea-oggetto-div").fadeOut("slow");
                            $("#inserimento-annuncio-oggetti-presenti").val(resp);
                            $("#inserimento-annuncio-altri-campi-titolo").val($("#inserimento-crea-oggetto-nome").val());
                            //$("#inserimento-annuncio-altri-campi-titolo-div").hide();
                        },
                        error: function () {
                            themeSpinner('hide');
                            $("#messageSelectObject").html('Problemi nel recuperare gli oggetti');
                            $("#messageSelectObject").addClass('alert-danger');
                            $("#messageSelectObject").show();
                        }

                    });
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageNewObject").html('Problemi nell\' inserimento dell\' oggetto');
                    $("#messageNewObject").addClass('alert-danger');
                    $("#messageNewObject").show();
                }

            });
        }

    });
    $("#button-inserimento-oggetto-nuovo").click(function () {
        $("#inserimento-crea-oggetto-div").fadeIn("slow");
        $("#inserimento-annuncio-oggetti-presenti-div").fadeOut("slow");
    });
//    $('#inserimento-annuncio-altri-campi-good-crossing-point').change(function () {
//
//        if(this.value!=='')
//        {
//            $('#inserimento-annuncio-altri-campi-localizzazione').val('');
//            $('#inserimento-annuncio-altri-campi-indirizzi-personali').val('');
//        }
//    });
//    $('#inserimento-annuncio-altri-campi-localizzazione').change(function () {
//
//        if(this.value!=='')
//        {
//            $('#inserimento-annuncio-altri-campi-good-crossing-point').val('');
//            $('#inserimento-annuncio-altri-campi-indirizzi-personali').val('');
//        }
//    });
//    $('#inserimento-annuncio-altri-campi-indirizzi-personali').change(function () {
//
//        if(this.value!=='')
//        {
//            $('#inserimento-annuncio-altri-campi-good-crossing-point').val('');
//            $('#inserimento-annuncio-altri-campi-localizzazione').val('');
//        }
//    });


    $("#button-inserimento-crea-annuncio").click(function () {
        $('#messageInsertOffer').html('');
        $("#messageInsertOffer").removeClass('alert-danger');
        $("#messageInsertOffer").removeClass('alert-success');
        $("#messageInsertOffer").hide();
        var reg_oggetto = $('#inserimento-annuncio-oggetti-presenti').val();
        var reg_condizioni = $('#inserimento-annuncio-altri-campi-condizioni').val();
        var reg_good_crossing_point = $('#inserimento-annuncio-altri-campi-good-crossing-point').val();
        var reg_localizzazione = $('#inserimento-annuncio-altri-campi-localizzazione').val();
        var reg_indirizzi_personali = $('#inserimento-annuncio-altri-campi-indirizzi-personali').val();
        var reg_titolo = $('#inserimento-annuncio-altri-campi-titolo').val();
        //var reg_foto_1 = $('#inserimento-annuncio-altri-campi-foto-1').val();
        var reg_foto_1 = $('#inserimento-annuncio-altri-campi-foto-1')[0].files[0];
        //var reg_foto_2 = $('#inserimento-annuncio-altri-campi-foto-2').val();
        var reg_foto_2 = $('#inserimento-annuncio-altri-campi-foto-2')[0].files[0];
        //var reg_foto_3 = $('#inserimento-annuncio-altri-campi-foto-3').val();
        var reg_foto_3 = $('#inserimento-annuncio-altri-campi-foto-3')[0].files[0];

        var reg_note_consegna = $('#inserimento-annuncio-altri-campi-note_consegna').val();

        var faiAjax = true;



//        debugger;



//        if($('input[name=inserimento-annuncio-tipologia-ritiro]:checked').val()===undefined)
//        {
//            if ($('input[name=inserimento-annuncio-tipologia]:checked').val()!==tipologia_cerco)// se la tipologia di annuncio non è cerco 
//            {
//                rimuovi_stato('#inserimento-annuncio-tipologia-ritiro');
//                stato_errore('#inserimento-annuncio-tipologia-ritiro', 'Campo richiesto');
//                faiAjax = false;
//            }
//        }
        if (reg_titolo == '')
        {
            rimuovi_stato('#inserimento-annuncio-altri-campi-titolo');
            stato_errore('#inserimento-annuncio-altri-campi-titolo', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#inserimento-annuncio-altri-campi-titolo');
            stato_success('#inserimento-annuncio-altri-campi-titolo');
        }
        if (reg_oggetto == '' && $('input[name=inserimento-annuncio-tipologia]:checked').val() !== tipologia_cerco)// se la tipologia di annuncio non è cerco 
        {
            rimuovi_stato('#inserimento-annuncio-oggetti-presenti');
            stato_errore('#inserimento-annuncio-oggetti-presenti', 'Campo richiesto');
            faiAjax = false;
        }
        else
        {
            rimuovi_stato('#inserimento-annuncio-oggetti-presenti');
            stato_success('#inserimento-annuncio-oggetti-presenti');
        }
        if (reg_condizioni == null || reg_condizioni == '')
        {
            if ($('input[name=inserimento-annuncio-tipologia]:checked').val() !== tipologia_cerco)// se non è un cerco  è obbligatoria la condizione
            {
                rimuovi_stato('#inserimento-annuncio-altri-campi-condizioni');
                stato_errore('#inserimento-annuncio-altri-campi-condizioni', 'Campo richiesto');
                faiAjax = false;
            }
            else
            {
                reg_condizioni == '';
            }
        }
        else
        {
            rimuovi_stato('#inserimento-annuncio-altri-campi-condizioni');
            stato_success('#inserimento-annuncio-altri-campi-condizioni');
        }
        if ((reg_good_crossing_point == null || reg_good_crossing_point == '') && (reg_localizzazione == null || reg_localizzazione == '') && (reg_indirizzi_personali == null || reg_indirizzi_personali == ''))
        {
            if ($('input[name=inserimento-annuncio-tipologia]:checked').val() !== tipologia_cerco)// se non è un cerco  è obbligatoria la localizzazione
            {
                rimuovi_stato('#inserimento-annuncio-altri-campi-good-crossing-point');
                stato_errore('#inserimento-annuncio-altri-campi-good-crossing-point', 'Almeno un campo richiesto tra Punto ToornaQui, localizzazione e indirizzi personali');
                rimuovi_stato('#inserimento-annuncio-altri-campi-localizzazione');
                stato_errore('#inserimento-annuncio-altri-campi-localizzazione', 'Almeno un campo richiesto tra Punto ToornaQui, localizzazione e indirizzi personali');
                rimuovi_stato('#inserimento-annuncio-altri-campi-indirizzi-personali');
                stato_errore('#inserimento-annuncio-altri-campi-indirizzi-personali', 'Almeno un campo richiesto tra Punto ToornaQui, localizzazione e indirizzi personali');
                faiAjax = false;
            }
        }
        else
        {
            rimuovi_stato('#inserimento-annuncio-altri-campi-good-crossing-point');
            stato_success('#inserimento-annuncio-altri-campi-good-crossing-point');
            rimuovi_stato('#inserimento-annuncio-altri-campi-localizzazione');
            stato_success('#inserimento-annuncio-altri-campi-localizzazione');
            rimuovi_stato('#inserimento-annuncio-altri-campi-indirizzi-personali');
            stato_success('#inserimento-annuncio-altri-campi-indirizzi-personali');
        }
        var msgtmp = '';
        if (typeof(reg_foto_1) !== 'undefined' && reg_foto_1 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_1);
            if (tmp)
            {
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_success('#inserimento-annuncio-altri-campi-foto');
            }
            else
            {
                faiAjax = false;
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                msgtmp = 'Attenzione il file 1 deve essere in formato jpeg o png  e non superiore a 8MB';
                stato_errore('#inserimento-annuncio-altri-campi-foto', msgtmp);
            }
        }
        else
        {
            if ($('input[name=inserimento-annuncio-tipologia]:checked').val() !== tipologia_cerco)// se non è un cerco  è obbligatoria la foto
            {
                faiAjax = false;
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                msgtmp = 'Attenzione la foto 1 è obbligatoria';
                stato_errore('#inserimento-annuncio-altri-campi-foto', msgtmp);
            }
        }
         if (typeof(reg_foto_2) !== 'undefined' && reg_foto_2 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_2);
            if (tmp)
            {
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_success('#inserimento-annuncio-altri-campi-foto');
            }
            else
            {
                faiAjax = false;
                msgtmp += '<br>Attenzione il file 2 deve essere in formato jpeg o png  e non superiore a 8MB';
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_errore('#inserimento-annuncio-altri-campi-foto', msgtmp);
            }
        }
         if (typeof(reg_foto_3) !== 'undefined' && reg_foto_3 != null)
        {
            var tmp = controlloFileImmagine(reg_foto_3);
            if (tmp)
            {
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_success('#inserimento-annuncio-altri-campi-foto');
            }
            else
            {
                faiAjax = false;
                msgtmp += '<br>Attenzione il file 3 deve essere in formato jpeg o png  e non superiore a 8MB';
                rimuovi_stato('#inserimento-annuncio-altri-campi-foto');
                stato_errore('#inserimento-annuncio-altri-campi-foto', msgtmp);
            }
        }
        if (faiAjax)
        {
            themeSpinner('show');
            form = new FormData();
            // carico ilform tramit formdata per upload del file
            form.append('oggetto', reg_oggetto);
            form.append('condizioni', reg_condizioni);
            form.append('good_crossing_point', reg_good_crossing_point);
            form.append('localizzazione', reg_localizzazione);
            form.append('indirizzi_personali', reg_indirizzi_personali);
            form.append('titolo', reg_titolo);
            
            var file1=null;
            var file2=null;
            var file3 =null;
            if (typeof(reg_foto_1) !== 'undefined' && reg_foto_1 != null)
            {
                dataURL1=$('#inserimento-annuncio-altri-campi-immaginecompressa-1').attr('src');
                file1=base64ToFile(dataURL1.split(',')[1], reg_foto_1.name, 'image/jpeg');
            }
            if (typeof(reg_foto_2) !== 'undefined' && reg_foto_2 != null)
            {
                dataURL2=$('#inserimento-annuncio-altri-campi-immaginecompressa-2').attr('src');
                file2=base64ToFile(dataURL2.split(',')[1], reg_foto_2.name, 'image/jpeg');
            }
            if (typeof(reg_foto_3) !== 'undefined' && reg_foto_3 != null)
            {
                dataURL3=$('#inserimento-annuncio-altri-campi-immaginecompressa-3').attr('src');
                file3=base64ToFile(dataURL3.split(',')[1], reg_foto_3.name, 'image/jpeg');
            }
            form.append('foto_1', file1);
            form.append('foto_2', file2);
            form.append('foto_3', file3);
            form.append('note_consegna', reg_note_consegna);
            form.append('tipologia_annuncio', $('input[name=inserimento-annuncio-tipologia]:checked').val());
            form.append('action', 'inserimento_annuncio_action');
            $.ajax({//create an ajax request to load_page.php
                type: "POST",
                data: form,
                mimeType: 'multipart/form-data',
                contentType: false,
                cache: false,
                processData: false,
                dataType: "html",
                url: ajax_url,
                success: function (resp) {
                    themeSpinner('hide');

                    if (resp == "true") {
                        $('#inserimento-annuncio-tipologia-div').hide();
                        $('#inserimento-oggetto-tipologia-div').hide();
                        $('#inserimento-crea-oggetto-div').hide();
                        $('#messageNewObject').hide();
                        $('#inserimento-annuncio-oggetti-presenti-div').hide();
                        $('#inserimento-annuncio-altri-campi-div').hide();
                        $("#messageInsertOffer").html('Annuncio Inserito con Successo. L\'annuncio è visibile per 30 giorni.');
                        $("#messageInsertOffer").addClass('alert-success');
                        $("#messageInsertOffer").show();
                        var etop = $('#main-container').offset().top;
                        $(window).scrollTop(etop);
                    }
                    else {
                        $("#messageInsertOffer").html('Si sono verificati dei problemi nell\' inserimento dell\' annuncio. Il tuo annuncio non è stato inserito.');
                        $("#messageInsertOffer").addClass('alert-danger');
                        $("#messageInsertOffer").show();
                    }
                },
                error: function () {
                    themeSpinner('hide');
                    $("#messageInsertOffer").html('Si sono verificati dei problemi nell\' inserimento dell\' annuncio. Il tuo annuncio non è stato inserito.');
                    $("#messageInsertOffer").addClass('alert-danger');
                    $("#messageInsertOffer").show();
                }

            });

        }
    });
});